module.exports = __webpack_public_path__ + "media/src/images/bg/bg4-4edea0a54cd7703dca10f4c1e0865735.jpg";